<template>
  <div class="wrapper-list">
    <div class="element-list" v-for="(user, index) in usersToken" :key="index">
      <div class="card shadow mt-2">
        <div class="card-body">
          <div class="card-heading">
            {{ user.utilisateurNom }}
            <div class="button-actions">
              <span class="delete-acces" @click="openEditModal(user.id)">
                <font-awesome-icon
                        :icon="['fas', 'edit']"
                        class="text-primary"
                ></font-awesome-icon>
              </span>
              <span class="delete-acces" @click="handleDelete(user.id)">
              <font-awesome-icon
                      :icon="['fas', 'trash-alt']"
                      class="text-primary"
              ></font-awesome-icon>
              </span>
            </div>
          </div>
          <div class="card-info pt-2">
            {{ user.email }}<br />
            <p class="actions-taken pt-2 mb-0">
              <small style="font-weight: 600;"> Crée le {{ user.created_at }} | Dernière modification le {{ user.updated_at }}</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    usersToken: {
      type: Array
    }
  },
  methods: {
    handleDelete (id) {
      this.$emit('onDeleteInvitation', id)
    },
    openEditModal (id) {
      this.$emit('openEditModal', id)
    }
  }
}
</script>

<style lang="scss">
.delete-acces {
  cursor: pointer;
}

.card-heading {
  position:relative;
}

.button-actions {
  position: absolute;
  right: 0;
  top: 0;
}
.element-list {
  .card {
    &.shadow {
      box-shadow: 0 2px 3px 0 rgba(225, 225, 225, 0.5) !important;
    }
  }
  .card-body {
    padding-top: 10px;
    padding-bottom: 10px;
    font-family: "Open Sans";
    font-size: 13px;
    font-weight: 600;
  }
}

.listing-box {
  .scroll-area {
    margin-right: -15px;
    padding-right: 15px;
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #2b3085 !important;
    width: 6px !important;
    right: 0;
    &:hover {
      background-color: #2b3085;
      width: 6px;
    }
  }
  .ps__rail-y {
    display: block;
    width: 8px;
    border: 1px solid #2b3085;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/voletLaterale/accesEnVue/listingToken.vue